<template>
  <div id="app" class="container">
    <b-form-checkbox class="float-right" v-model="weeklyView" name="check-button" button>
      Toggle Weekly View
    </b-form-checkbox>
    <timetable v-if="weeklyView" />
    <dailyShows v-else />
  </div>
</template>

<script>
import Timetable from './components/Timetable.vue'
import DailyShows from './components/DailyShows.vue'
import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

export default {
  name: 'App',
  props: {
    weeklyView: Boolean
  },
  components: {
    Timetable,
    DailyShows
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
